// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import categoryItemSharedStyles from "@guestsupply/App/SharedStyles/categoryItemSharedStyles";
import { categoryDetailSubCategoriesStyles } from "@guestsupply/Overrides/Widgets/Category/CategoryDetailSubCategories";
import { mergeWithCss } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

categoryDetailSubCategoriesStyles.container = {
    ...mergeWithCss(categoryItemSharedStyles.container, {
        css: css`
            margin-bottom: 4px;
        `,
    }),
};

categoryDetailSubCategoriesStyles.subCategoryItem = {
    ...mergeWithCss(categoryItemSharedStyles.categoryItem, {
        css: css`
            padding-bottom: 8px;
        `,
    }),
    width: [12, 6, 6, 4, 3],
};

categoryDetailSubCategoriesStyles.categoryContainer = {
    ...mergeWithCss(categoryItemSharedStyles.categoryContainer, {
        css: css`
            padding: 18px 18px 4px 18px;
        `
    }),
};

categoryDetailSubCategoriesStyles.innerContainer = {
    ...categoryItemSharedStyles.innerContainer,
};

categoryDetailSubCategoriesStyles.subCategoryImageClickable = {
    ...categoryItemSharedStyles.categoryImageLink,
};

categoryDetailSubCategoriesStyles.subCategoryImage = {
    ...categoryItemSharedStyles.categoryImage,
};

categoryDetailSubCategoriesStyles.subCategoryNameLink = {
    ...mergeWithCss(categoryItemSharedStyles.subCategoryNameLink, {
        css: css`
            word-break: keep-all;
        `
    }),
};

categoryDetailSubCategoriesStyles.categoryHeader = {
    ...categoryItemSharedStyles.categoryHeader,
};

categoryDetailSubCategoriesStyles.viewMoreLinkWrapper = {
    ...categoryItemSharedStyles.viewMoreLinkItem,
};

categoryDetailSubCategoriesStyles.viewMoreLink = {
    ...categoryItemSharedStyles.viewMoreLink,
};
